import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import * as SemanticActions from 'actions/semantic-action';
import { Frame, Toast } from '@shopify/polaris';
import _ from 'lodash';
import history from 'src/routes/history';
import { routes } from 'src/routes';

const SyncSemantic = (props) => {
  const {
    i18n,
    tenantId,
    semanticSettings,
    semantic,
    enableAISearch,
    getSemanticSettings,
    stopTriggerCheckSyncSemantic,
    triggerCheckSyncSemantic
  } = props;
  const { checkSyncSemantic, settings = {} } = semantic
  const { available } = settings;
  const [showSyncSuccess, setShowSyncSuccess] = React.useState(false);

  useEffect(() => {
    if (tenantId && semanticSettings.enable && !semanticSettings.available) {
      getSemanticSettings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  React.useEffect(() => {
    let reloadSyncInterval = undefined;

    if (checkSyncSemantic) {
      reloadSyncInterval = setInterval(() => {
        getSemanticSettings();
      }, 10000); // check every 10 second
    } else {
      clearInterval(reloadSyncInterval);
    }
    return () => clearInterval(reloadSyncInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkSyncSemantic]);

  useEffect(() => {
    if (available && checkSyncSemantic) {
      stopTriggerCheckSyncSemantic();
      setShowSyncSuccess(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [available]);

  useEffect(() => {
    if (available !== undefined && !available && enableAISearch) {
      triggerCheckSyncSemantic();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [available, enableAISearch]);

  return (
    <div style={{ height: '1px' }}>
      {showSyncSuccess && (
        <Frame>
          <Toast
            content={i18n.translate('AdminHTML.SemanticSearch.Actions.syncSuccess')}
            duration={45000}
            action={{
              content: i18n.translate('AdminHTML.SemanticSearch.Actions.explore'),
              onAction: () => {
                history.push(routes.semanticSearch.view());
                setShowSyncSuccess(false);
              }
            }}
            onDismiss={() => setShowSyncSuccess(false)}
          />
        </Frame>
      )}
    </div>
  );
};

const SyncNotification = (props) => {

  return (
    <SyncSemantic {...props} />
  );
};

const mapStateToProps = (state, props) => {
  return {
    semantic: state.semantic,
    enableAISearch: _.get(
      state.oauth.tenantApp,
      'settings.instantSearch.settings.AI-synonyms',
      false
    ),
    tenantId: _.get(state.oauth.tenantApp, 'tenantId', ''),
    semanticSettings: _.get(state.oauth.tenantApp, 'settings.semanticSearch.settings', '')
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getSemanticSettings: () => dispatch(SemanticActions.getSemanticSettings()),
  stopTriggerCheckSyncSemantic: () => dispatch(SemanticActions.stopTriggerCheckSyncSemantic()),
  triggerCheckSyncSemantic: () => dispatch(SemanticActions.triggerCheckSyncSemantic())
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SyncNotification));
